import { Button } from '../../../cdl/Button/Button';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

interface ReplaceLubricationChartModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
}

export const ReplaceLubricationChartModal = ({ isOpen, onDismiss, onConfirm }: ReplaceLubricationChartModalProps) => {
    return (
        <Modal isOpen={isOpen} scrollable={false} onDismiss={onDismiss} dismissible={false}>
            <Box display="grid" gap={16} padding={24}>
                <Text variant="title">{translate('vessel.products.replaceModal.headline')}</Text>

                <Text variant="small" color="foreground.muted">
                    {translate('vessel.products.replaceModal.description')}
                </Text>

                <Box display="flex" justifyContent="end" gap={8}>
                    <Button type="button" onClick={onDismiss}>
                        {translate('btn.cancel')}
                    </Button>
                    <Button emphasis="high" type="button" destructive onClick={onConfirm}>
                        {translate('vessel.products.replaceModal.replace')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};
